import { render, staticRenderFns } from "./ContentFooter.vue?vue&type=template&id=15b22aed&scoped=true&"
var script = {}
import style0 from "./ContentFooter.vue?vue&type=style&index=0&id=15b22aed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b22aed",
  null
  
)

export default component.exports